module.exports = __webpack_public_path__ + "static/media/PESSOYA_MENU-normal.b5e906be.png";